import React from 'react';
import { Flex, Link, Text, Title } from '@gjensidige/builders-components';
import { GdprComponentSe } from '@gjensidige/gdpr-component-se';

import styles from './style.scss';
import { CalculationInputs } from './components/CalculationInputs/CalculationInputs';
import { IllustrationSection } from './components/IllustrationSection/IllustrationSection';
import { CalculationWidgetProps } from './Types';

export const CalculationWidget: React.FC<CalculationWidgetProps> = (
  props: CalculationWidgetProps
) => {
  const {
    image,
    imageAltText,
    smallScreenImage,
    headerText,
    inputLists,
    footerMessageClassName,
    footerMessage
  } = props;

  return (
    <Flex>
      <div className={`${styles.widgetWrapper}`}>
        <Flex layout={{ sm: 1, md: 2 }}>
          {/* <Col lg="5" md="5" sm="12" className={styles.imageContainer}> */}
          <div className={styles.imageContainer}>
            <IllustrationSection
              imageUrl={image}
              imageAltText={imageAltText}
              smallScreenImage={smallScreenImage}
            />
          </div>
          {/* </Col> */}
          {/* <Col sm="12" lg="7" md="7" className={styles.inputContainer}> */}
          <Flex center="md" className={styles.inputContainer}>
            <div className={styles.inputContentWrapper}>
              <Title
                as={'h2'}
                size="5"
                className={styles.calculationWidgetHeader}
              >
                {headerText}
              </Title>
              <div className={styles.calculationWidgetInputSection}>
                <div className={styles.rightContainer}>
                  <CalculationInputs
                    calculationInputs={inputLists.calculationInputs}
                    calculateBtn={inputLists.calculateBtn}
                  />

                  {footerMessage && (
                    <Text
                      size="small"
                      className={`${styles.footerInfo} ${footerMessageClassName}`}
                    >
                      {footerMessage}
                    </Text>
                  )}
                </div>
              </div>
            </div>
          </Flex>
          {/* </Col> */}
          {/* </Row> */}
        </Flex>
      </div>
    </Flex>
  );
};
